package com.neurobs.util

import io.circe.{Decoder, Encoder}

case class TimeSeconds(value: Double) extends AnyVal {
	def seconds(): Double = value
	def ms(): Double = value / 1000

	def zero(): Boolean = value == 0
	def positive(): Boolean = value > 0
	def negative(): Boolean = value < 0
	def nonNegative(): Boolean = value >= 0
	def nonPositive(): Boolean = value <= 0

	def +(rhs: TimeSeconds): TimeSeconds = TimeSeconds(value + rhs.value)
	def -(rhs: TimeSeconds): TimeSeconds = TimeSeconds(value - rhs.value)
	def *(rhs: Double): TimeSeconds = TimeSeconds(value * rhs)
	def /(rhs: Double): TimeSeconds = TimeSeconds(value / rhs)

	def >(rhs: TimeSeconds): Boolean = value > rhs.value
	def >=(rhs: TimeSeconds): Boolean = value >= rhs.value
	def <(rhs: TimeSeconds): Boolean = value < rhs.value
	def <=(rhs: TimeSeconds): Boolean = value <= rhs.value

	def min(rhs: TimeSeconds): TimeSeconds = TimeSeconds(value.min(rhs.value))
	def max(rhs: TimeSeconds): TimeSeconds = TimeSeconds(value.max(rhs.value))
	def abs(): TimeSeconds = TimeSeconds(value.abs)
}

case class TimeDMS(value: Double) extends AnyVal {
	def timeSeconds(): TimeSeconds = TimeSeconds(value / 10000)
}

object TimeSeconds {

	type TimeSecondsInterval = Interval[TimeSeconds]

	implicit val circeEncoderTimeSeconds: Encoder[TimeSeconds] = (t: TimeSeconds) => io.circe.Json.fromDouble(t.value).get
	implicit val circeDecodertimeSeconds: Decoder[TimeSeconds] = (c: io.circe.HCursor) => c.as[Double].map(t => TimeSeconds(t))

	implicit val circeEncoderTimeDMS: Encoder[TimeDMS] = (t: TimeDMS) => io.circe.Json.fromDouble(t.value).get
	implicit val circeDecoderTimeDMS: Decoder[TimeDMS] = (c: io.circe.HCursor) => c.as[Double].map(t => TimeDMS(t))

	implicit object IntervalNumeric extends Interval.IntervalNumeric[TimeSeconds] {
		def minus(x: TimeSeconds, y: TimeSeconds): TimeSeconds = x - y
		def abs(x: TimeSeconds): TimeSeconds = x.abs()
		def min(x: TimeSeconds, y: TimeSeconds): TimeSeconds = x.min(y)
		def max(x: TimeSeconds, y: TimeSeconds): TimeSeconds = x.max(y)
		def lteq(x: TimeSeconds, y: TimeSeconds): Boolean = x <= y
	}
}